/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_account_already_exists = /** @type {(inputs: {}) => string} */ () => {
	return `Pro tento e-mail již existuje účet. Pokud si jste jisti, že jste správně zadali svůj e-mail, kliknutím zde obnovte heslo a přistupte ke svému účtu.`
};

const da_account_account_already_exists = /** @type {(inputs: {}) => string} */ () => {
	return `Der findes allerede en konto med denne email. Hvis du er sikker på, at du har indtastet din email korrekt, klik her for at nulstille din adgangskode og få adgang til din konto.`
};

const de_account_account_already_exists = /** @type {(inputs: {}) => string} */ () => {
	return `Für diese E-Mail existiert bereits ein Konto. Wenn Sie sicher sind, dass Sie die E-Mail korrekt eingegeben haben, klicken Sie hier, um Ihr Passwort zurückzusetzen und auf Ihr Konto zuzugreifen.`
};

const en_account_account_already_exists = /** @type {(inputs: {}) => string} */ () => {
	return `An account already exists for this email. If you are sure you have entered your email correctly, click here to retrieve your password and access your account.`
};

const es_account_account_already_exists = /** @type {(inputs: {}) => string} */ () => {
	return `Ya existe una cuenta para este correo. Si estás seguro de haber introducido correctamente tu correo, haz clic aquí para recuperar tu contraseña y acceder a tu cuenta.`
};

const fr_account_account_already_exists = /** @type {(inputs: {}) => string} */ () => {
	return `Il existe déjà un compte pour cet email. Si vous êtes sûr d'avoir correctement saisi votre email, cliquez ici pour récupérer votre mot de passe et accéder à votre compte.`
};

const hu_account_account_already_exists = /** @type {(inputs: {}) => string} */ () => {
	return `Ehhez az e-mailhez már létezik fiók. Ha biztosan helyesen adtad meg az e-mailt, kattints ide a jelszó helyreállításához és a fiók eléréséhez.`
};

const it_account_account_already_exists = /** @type {(inputs: {}) => string} */ () => {
	return `Esiste già un account per questa email. Se sei sicuro di aver inserito correttamente l'email, clicca qui per recuperare la password e accedere.`
};

const nl_account_account_already_exists = /** @type {(inputs: {}) => string} */ () => {
	return `Er bestaat al een account voor dit e-mailadres. Ben je zeker van je e-mailadres, klik dan hier om je wachtwoord te herstellen en toegang te krijgen tot je account.`
};

const pl_account_account_already_exists = /** @type {(inputs: {}) => string} */ () => {
	return `Konto z tym adresem e-mail już istnieje. Jeśli jesteś pewien poprawności adresu, kliknij tutaj, aby odzyskać hasło i uzyskać dostęp do konta.`
};

const pt_account_account_already_exists = /** @type {(inputs: {}) => string} */ () => {
	return `Já existe uma conta para este e-mail. Se você tem certeza de que digitou corretamente, clique aqui para recuperar sua senha e acessar sua conta.`
};

const sv_account_account_already_exists = /** @type {(inputs: {}) => string} */ () => {
	return `Det finns redan ett konto för denna e-post. Om du är säker på att du har angett rätt e-post, klicka här för att återställa ditt lösenord.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_account_already_exists = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_account_already_exists(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_account_already_exists", locale)
	if (locale === "cs") return cs_account_account_already_exists(inputs)
	if (locale === "da") return da_account_account_already_exists(inputs)
	if (locale === "de") return de_account_account_already_exists(inputs)
	if (locale === "en") return en_account_account_already_exists(inputs)
	if (locale === "es") return es_account_account_already_exists(inputs)
	if (locale === "fr") return fr_account_account_already_exists(inputs)
	if (locale === "hu") return hu_account_account_already_exists(inputs)
	if (locale === "it") return it_account_account_already_exists(inputs)
	if (locale === "nl") return nl_account_account_already_exists(inputs)
	if (locale === "pl") return pl_account_account_already_exists(inputs)
	if (locale === "pt") return pt_account_account_already_exists(inputs)
	return sv_account_account_already_exists(inputs)
};
export { account_account_already_exists as "account.account_already_exists" }